function dialogDrag(el, binding, vNode) {
  let dialogHeaderEl;
  let dragDom;
  if (binding.modifiers.custom) {
    const { header, wrapper } = binding.value;
    if (!header || !wrapper) {
      throw new Error('自定义拖拽，未传参header或wrapper!');
    }
    dialogHeaderEl = el.querySelector(header);
    dragDom = el.querySelector(wrapper);
  } else {
    dialogHeaderEl = el.querySelector('.el-dialog-header');
    dragDom = el.querySelector('.wps-el-dialog');
  }

  // dragDom.style.cssText += ';top:0px;';

  // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
  const getStyle = (function () {
    if (window.document.currentStyle) {
      return (dom, attr) => dom.currentStyle[attr];
    }
    // @ts-ignore
    return (dom, attr) => getComputedStyle(dom, false)[attr];
  })();

  dialogHeaderEl.onmousedown = (e) => {
    e.preventDefault();

    // 鼠标按下，计算当前元素距离可视区的距离
    const disX = e.clientX - dialogHeaderEl.offsetLeft;
    const disY = e.clientY - dialogHeaderEl.offsetTop;

    const dragDomWidth = dragDom.offsetWidth;
    const dragDomHeight = dragDom.offsetHeight;

    const screenWidth = document.body.clientWidth;
    const screenHeight = document.body.clientHeight;

    const minDragDomLeft = dragDom.offsetLeft;
    // 出现滚动条可能出现右侧边界判断有问题 暂不处理
    const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth;

    const minDragDomTop = dragDom.offsetTop;
    const maxDragDomTop =
      screenHeight - dragDom.offsetTop - dragDomHeight;

    // 获取到的值带px 正则匹配替换
    let styL = getStyle(dragDom, 'left');
    let styT = getStyle(dragDom, 'top');

    if (styL.includes('%')) {
      styL = +document.body.clientWidth * (+styL.replace(/\%/g, '') / 100);
      styT = +document.body.clientHeight * (+styT.replace(/\%/g, '') / 100);
    } else {
      styL = +styL.replace(/\px/g, '');
      styT = +styT.replace(/\px/g, '');
    }

    /* dom元素的宽度与浏览器screen宽度差10则不作为 */
    if (screenWidth >= dragDomWidth + 10) {
      document.onmousemove = function (ev) {
        // 通过事件委托，计算移动的距离
        let left = ev.clientX - disX;
        let top = ev.clientY - disY;

        // 边界处理
        if (-left > minDragDomLeft) {
          left = -minDragDomLeft;
        } else if (left > maxDragDomLeft) {
          left = maxDragDomLeft;
        }

        if (-top > minDragDomTop) {
          top = -minDragDomTop;
        } else if (top > maxDragDomTop) {
          // 优化边界处理 dialog高出屏幕时不进行下边界判断
          if (screenHeight > dragDomHeight) {
            top = maxDragDomTop;
          }
        }

        // 移动当前元素
        // dragDom.style.cssText += `;left:${left + styL}px;top:${top + styT}px;`;
        dragDom.style.cssText = `;left:${left + styL}px;top:${top + styT}px;`;

        // emit onDrag event
        // vNode.child.$emit('dragDialog');
      };
    }

    document.onmouseup = function () {
      document.onmousemove = null;
      document.onmouseup = null;
    };
  };
}

export default {
  bind: dialogDrag,
  update: dialogDrag,
};



// WEBPACK FOOTER //
// ./src/directive/directiveOtherFn/dialogDrag.js